<template>
<CContainer>
    <CRow>
        <CCol col="12" class="d-flex overflow-auto px-0">
            <CreateBtn @click="showCreateModal" v-if="$policy('agreement').create" class="mfe-2" />
            <FilterIt class="mfe-2" />
            <SortIt class="min-w-fit-content mr-auto" />
        </CCol>
    </CRow>

    <Table class="mt-2" />

    <CModal :show.sync="createModal.show">
        <template #header-wrapper>
            <div></div>
        </template>

        <Form :submit="() => submit()" :agreement="agreement" ref="createAgreementForm" class="px-1" />

        <template #footer-wrapper>
            <div></div>
        </template>
    </CModal>
</CContainer>
</template>

<script>
import { mapActions } from 'vuex'
import { AgreementType, AgreementStatus } from '@/constants'
import { Table, FilterIt, SortIt, Form } from './partials'

export default {
    name: 'List',

    components: {
        FilterIt,
        SortIt,
        Table,
        Form,
    },

    data() {
        return {
            AgreementType,
            AgreementStatus,
            createModal: {
                show: false,
                item: {},
            },
            agreement: {
                file: '',
                type: '',
                user_id: null,
                status: AgreementStatus.PENDING,
                is_locked: 0,
                started_at: '',
                finished_at: '',
            },
        }
    },

    methods: {
        ...mapActions({
            create: 'agreement/create',
            setMsg: 'messageComponent/setMsg',
            resetMsg: 'messageComponent/resetMsg',
            setShowLoading: 'loadingComponent/setShowLoading',
            fetchUsers: 'user/fetchForSelect',
        }),
        showCreateModal() {
            this.resetMsg()
            this.setShowLoading(false)
            this.getUsers() // If the user has permission to create agreement for other users

            this.$refs.createAgreementForm.$refs.form.reset()
            this.$refs.createAgreementForm.destory()
            this.agreement = {
                file: '',
                type: '',
                user_id: null,
                status: AgreementStatus.PENDING,
                is_locked: 0,
                started_at: '',
                finished_at: '',
            }

            this.createModal.show = true
        },
        getUsers() {
            if (!this.$policy('agreement').create_any_or_group) {
                return
            }

            this.fetchUsers()
        },
        submit() {
            const agreementForm = this.$refs.createAgreementForm
            this.setShowLoading()
            this.resetMsg()

            this.create(this.agreement).then(() => {
                this.setShowLoading(false)
                agreementForm.$refs.form.reset()
                agreementForm.destory()
                this.createModal.show = false
            }).catch(result => {
                if (result.data) {
                    agreementForm.$refs.form.setErrors(result.data)
                }
                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('tags.' + result.tag),
                    type: 'danger'
                })
            })
        }
    }
}
</script>